exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* .make_a_cmnt input\r\n{\r\n    border: 1px solid red !important; \r\n} */\r\n\r\n.commet-img {\r\n    width : 100px;\r\n    height:100px\r\n}", ""]);

